export class FilterBrouillard {

    credit: number;
    debit: number;
    soldeinitial: number;
    solde: number;
    debut: Date;
    fin: Date;
    compte: string;
    devise: string;

}
export class FilterSuivi {
    nFiche: string="";
    finance=true;
 

    groupe: string="";

    client: string="" ;

    participant: string="" ;
    debut: Date;
    fin: Date;
    devise: number;
    echeance: Date;
    status:string;

    sortBy:string;

}  

export class FilterClient{

    userId:number;
    socifact:string
    pavillon:string
    pays:string
    typeClient:string
    langue: string;
    maxResult:number;
    stranger:string;
    status:string;
    commercial:number;
    paiement: string;
}
